import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncPodcastV2 = loadable(() => import("./PodcastV2"), {
  fallback: <FullPageLoader />,
});

/**
 * ⚠️  `export default (` — AN ANONYMOUS ARROW, NOT A NAMED COMPONENT. This file
 * used to export `const PodcastV2Page = …; export default PodcastV2Page;`, which
 * `scripts/verify-wrapper-hoc.js` rejects: a named default export is expected to
 * carry `wrapperHOC`. Route entry points are not wrapped — the page component
 * itself is — so the anonymous form is what the check allows, and it is what
 * AmbassadorV2 and MediaMentionsV2 already do.
 *
 * ⚠️  AND IT WAS MISSING `ErrorBoundary`, which both sibling pages have. A throw
 * inside the loadable subtree took the whole route down with it instead of being
 * caught here.
 */
export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncPodcastV2 {...props} />
  </ErrorBoundary>
);
